module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-change-password"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "cp-modal-title"
  }, [_vm._v("ĐỔI MẬT KHẨU")]), _c('span', {
    staticClass: "cp-modal-btn-close material-icons",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _c('form', {
    attrs: {
      "action": "#",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.errorArray],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nhập mật khẩu hiện tại")]), ((_vm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordOld),
      expression: "passwordOld"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordOld",
      "required": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.passwordOld) ? _vm._i(_vm.passwordOld, null) > -1 : (_vm.passwordOld)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.passwordOld,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.passwordOld = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.passwordOld = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.passwordOld = $$c
        }
      }
    }
  }) : ((_vm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordOld),
      expression: "passwordOld"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordOld",
      "required": "required",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.passwordOld, null)
    },
    on: {
      "change": function($event) {
        _vm.passwordOld = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordOld),
      expression: "passwordOld"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordOld",
      "required": "required",
      "type": _vm.passwordType
    },
    domProps: {
      "value": (_vm.passwordOld)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordOld = $event.target.value
      }
    }
  }), (_vm.passwordType === 'text') ? _c('i', {
    staticClass: "material-icons cp-icon-password",
    on: {
      "click": _vm.switchVisibility
    }
  }, [_vm._v("visibility")]) : _c('i', {
    staticClass: "material-icons cp-icon-password",
    on: {
      "click": _vm.switchVisibility
    }
  }, [_vm._v("visibility_off")])])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.errorArray],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mật khẩu mới")]), ((_vm.secondPasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordNew),
      expression: "passwordNew"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordNew",
      "required": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.passwordNew) ? _vm._i(_vm.passwordNew, null) > -1 : (_vm.passwordNew)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        var $$a = _vm.passwordNew,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.passwordNew = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.passwordNew = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.passwordNew = $$c
        }
      }
    }
  }) : ((_vm.secondPasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordNew),
      expression: "passwordNew"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordNew",
      "required": "required",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.passwordNew, null)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        _vm.passwordNew = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordNew),
      expression: "passwordNew"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordNew",
      "required": "required",
      "type": _vm.secondPasswordType
    },
    domProps: {
      "value": (_vm.passwordNew)
    },
    on: {
      "keyup": _vm.checkPassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordNew = $event.target.value
      }
    }
  }), (_vm.secondPasswordType === 'text') ? _c('i', {
    staticClass: "material-icons cp-icon-password",
    on: {
      "click": _vm.switchVisibilityNew
    }
  }, [_vm._v("visibility")]) : _c('i', {
    staticClass: "material-icons cp-icon-password",
    on: {
      "click": _vm.switchVisibilityNew
    }
  }, [_vm._v("visibility_off")])])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group custom-form-group",
    class: [_vm.errorArray],
    staticStyle: {
      "position": "relative"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nhập lại mật khẩu mới")]), ((_vm.confirmPasswordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirm),
      expression: "passwordConfirm"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordConfirm",
      "required": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.passwordConfirm) ? _vm._i(_vm.passwordConfirm, null) > -1 : (_vm.passwordConfirm)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        var $$a = _vm.passwordConfirm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.passwordConfirm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.passwordConfirm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.passwordConfirm = $$c
        }
      }
    }
  }) : ((_vm.confirmPasswordType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirm),
      expression: "passwordConfirm"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordConfirm",
      "required": "required",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.passwordConfirm, null)
    },
    on: {
      "keyup": _vm.checkPassword,
      "change": function($event) {
        _vm.passwordConfirm = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirm),
      expression: "passwordConfirm"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-right": "40px !important"
    },
    attrs: {
      "id": "passwordConfirm",
      "required": "required",
      "type": _vm.confirmPasswordType
    },
    domProps: {
      "value": (_vm.passwordConfirm)
    },
    on: {
      "keyup": _vm.checkPassword,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirm = $event.target.value
      }
    }
  }), (_vm.confirmPasswordType === 'text') ? _c('i', {
    staticClass: "material-icons cp-icon-password",
    on: {
      "click": _vm.switchVisibilityConfirm
    }
  }, [_vm._v("visibility")]) : _c('i', {
    staticClass: "material-icons cp-icon-password",
    on: {
      "click": _vm.switchVisibilityConfirm
    }
  }, [_vm._v("visibility_off")]), (!_vm.matched) ? _c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*Mật khẩu không khớp*")]) : _vm._e()])])])])]), _c('div', {
    staticClass: "modal-footer cp-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "cp-btn-save btn",
    on: {
      "click": _vm.submitChangePassword
    }
  }, [_vm._v("Lưu thay đổi")])])]), _c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "cp-btn-cancel btn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Huỷ bỏ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e56d70a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/changePassword.vue
// module id = 1501
// module chunks = 0